import { Paper, Grid } from "@material-ui/core";
import {
	InputCheckboxMaster,
	InputOptionMaster,
	InputTextMaster,
	LabelRequired,
} from "App/Component/ui";
import { useSelectOption } from "App/hooks";
import {
	selectAlamatLokasi,
	useCity,
	useDistrict,
	useSubDistrict,
} from "../helpers";
import { TYPE_INSTANCE2 } from "App/constants";
import LokasiAlamatForm from "./LokasiAlamatForm";

export default function LokasiAlamat({ formDataAlamat, setFormDataAlamat }) {
	return (
		<>
			<Paper className="p-1 mb-1">
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
					}}
				>
					<h4>ALAMAT LOKASI</h4>
					<InputCheckboxMaster
						checked={formDataAlamat.available}
						name="available"
						id="available"
						label="Punya Alamat Lokasi ?"
						onChange={() =>
							setFormDataAlamat({
								...formDataAlamat,
								available: !formDataAlamat.available,
							})
						}
					/>
				</div>

				{formDataAlamat.available === false ? (
					<></>
				) : (
					<>
						<LokasiAlamatForm
							formDataAlamat={formDataAlamat}
							setFormDataAlamat={setFormDataAlamat}
						/>
					</>
				)}
			</Paper>
		</>
	);
}
